module.exports = __webpack_public_path__ + "static/media/tatGrid.444d1bb8.jpg";